var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-area',{attrs:{"voltar":"true","pageTitle":"Hackers :: AVIATOR"}}),_c('aviator-content-area'),_c('menu-area'),_c('footer-area')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }